import TimezoneSelector from "./timezone-selector.vue";

export default TimezoneSelector;



// WEBPACK FOOTER //
// ./src/components/_timezone-selector/index.js